module.exports = __webpack_public_path__ + "static/media/PoliceSirenLong.3fad1154.mp3";